import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Error from '@/_utils/Error'

import { Layout, Dantzig, } from '@/pages/Export'


const RouterViews = () => {
  return (
    <Routes>
      <Route element={<Layout/>}>
        <Route index element={<Dantzig/>}></Route>
        
        <Route path="Dantzig/*" element={
          <Routes>
            <Route index element={<Dantzig/>}></Route>
            <Route path="/" element={<Dantzig/>}></Route>
            <Route path="*" element={<Error/>}></Route>
          </Routes>
        }></Route>

      </Route>
      
      <Route path="*" element={<Error/>}></Route>
    </Routes>
  )
}

export default RouterViews